module.exports = __webpack_public_path__ + "poppins-v15-latin-regular.woff2";